import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import DataManagementPanelFull from './DataManagementPanelFull';
import DataManagementPanelNarrow from './DataManagementPanelNarrow';

const DataManagementPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: DataManagementPanelFull, narrow: DataManagementPanelNarrow }}
    onChange={onChange}
    width={800}
  />
);

export default DataManagementPanel;
